import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import RestoreIcon from "@mui/icons-material/Restore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Autocomplete,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Chip,
  Grid,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Paper,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import {
  createSearchParams,
  Link as LinkRRD,
  useNavigate,
} from "react-router-dom";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
// import DrawerUI from '../../components/Drawer'
import { dateConvert } from "../../helper/dateConverter";
import Body from "../../layout/Body";

import { useStyles } from "../../theme/theme";
// import DeleteMission from './DeleteMission'
// import LiveMission from './LiveMission'
// import RestoreMission from './RestoreMission'
// import UnliveMission from './UnliveMission'
// import RedirectMission from './RedirectMission';
import { getAllChallengeAction } from "../../redux/toolkit/challenge/getAllChallenge";
import moment from "moment";
import { getAllLifeLineAction } from "../../redux/toolkit/lifeLine/allLifeLine";

// import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
// import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


let cat_id = "";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/allChallenge"
      >
        All Challenge
      </Link>
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      All Challenge
    </Typography>
  </Stack>
);
const AllChallenge = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const challengeData = useSelector((state) => state.allChallenge);
  const { data, loading, total, status } = challengeData;

  const [snack, setSnack] = useState(false);

  const [pageSize, setPageSize] = useState(25);
  const [mission_id, setmission_id] = useState("");
  const classes = useStyles();

  const [date, setDate] = useState({
    start: null,
    end: null,
  });

  const [isActive, setIsActive] = useState(0);
  const [isMission, setIsMission] = useState(0)
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 })


  console.log("data================>", data);

  const qnsDataGridColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      minWidth: 50,
      headerClassName: "super-app-theme--header",
      // renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1,
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber = (page * pageSize) +
          params?.api?.getRowIndex(params.row._id) + 1
        return serialNumber;
      }
    },
    {
      field: "_id",
      headerName: "ID",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <LinkRRD to={`/mission-detail?${params?.row?._id}`}>
            <Typography color="primary">{params?.row?._id}</Typography>
          </LinkRRD>
        );
      },
    },
    {
      field: "challenge_name",
      headerName: "Challenge name",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.challenge_name}</Typography>;
      },
    },

    {
      field: "is_active",
      headerName: "Is Active",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>{params?.row?.is_active ? "true" : "false"}</Typography>
        );
      },
    },


    {
      field: "is_mission",
      headerName: "Is Mission",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <Typography>{params?.row?.is_mission ? "true" : "false"}</Typography>
        );
      },
    },



    {
      field: "reward",
      headerName: "Reward",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.reward}</Typography>;
      },
    },

    {
      field: "attempt",
      headerName: "attempt",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.attempt}</Typography>;
      },
    },

    {
      field: "description",
      headerName: "description",
      flex: 1,
      minWidth: 270,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.description}</Typography>;
      },
    },

    {
      field: "duration",
      headerName: "duration",
      flex: 1,
      minWidth: 170,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.duration}</Typography>;
      },
    },


    {
      field: "how_to_use_points",
      headerName: "how_to_use_points",
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <>
            <Stack>
              {params?.row?.how_to_use_points?.map((item, idx) => {
                return (
                  <Typography key={params.row._id + "_" + idx}>
                    {item}
                  </Typography>
                );
              })}
            </Stack>
          </>
        );
      },
    },

    // {
    //   field: "createdAt",
    //   headerName: "createdAt",
    //   flex: 1,
    //   minWidth: 170,
    //   headerClassName: "super-app-theme--header",
    //   renderCell: (params) => {
    //     return <Typography>{params?.row?.createdAt}</Typography>;
    //   },
    // },

    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const date = params?.row?.createdAt;
        return (
          <Typography>
            {date ? moment(date).local().format("YYYY-MM-DD hh:mm::ss A") : "-"}
          </Typography>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit Category",
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              navigate({
                pathname: `/editChallenge`,
                search: createSearchParams({
                  challenge_id: params?.row?._id,
                }).toString(),
              });
              // dispatch(getSingleChallengeAction(params?.row?._id));
            }}
          >
            <EditIcon color="primary" />
          </IconButton>
        );
      },
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      //   hide: ativeFilter,
    },

    {
      field: "history",
      headerName: "Challenge History",
      renderCell: (params) => {
        return (
          // <IconButton
          //   onClick={() => {
          //     navigate({
          //       pathname: `/editChallenge`,
          //       search: createSearchParams({
          //         challenge_id: params?.row?._id,
          //       }).toString(),
          //     });
          //   }}
          // >
          //   <EditIcon color="primary" />
          // </IconButton>

          <Button
            variant="contained"
            onClick={() => {
              navigate({
                pathname: `/challengeHistory`,
                search: createSearchParams({
                  challenge_id: params?.row?._id,
                }).toString(),
              });

            }}
          >Challenge History</Button>
        );
      },
      headerClassName: "super-app-theme--header",
      flex: 1,
      minWidth: 150,
      //   hide: ativeFilter,
    },
  ];

  // fn
  //   const handleFilter = () => {
  //       dispatch(getMissionAction({ sub_cat_id: cat_id, is_deleted: ativeFilter }))
  //   }
  //   const handleclearFilter = () => {
  //       setActiveFilter(false)
  //       dispatch(getMissionAction({ is_deleted: false }))
  //   }
  const handleChallengeToggle = () => {
    navigate("/mission/live-bulk-mission");
  };

  //   const handleFilterData = () => {
  //       dispatch(getMissionAction({ is_deleted: false, s_date: dateConvert(date?.start), e_date: dateConvert(date?.end) }))
  //   }

  // use effect
  useEffect(() => {
    dispatch(getAllChallengeAction({ is_active: isActive, is_mission: isMission, page: pageState.page, limit: pageState.pageSize }));
  }, [dispatch, pageState.page, pageState.pageSize, isActive, isMission]);




  const handleChange = (e) => {
    setIsActive(e.target.value);
  };

  const handleMissionChange = (e) => {
    setIsMission(e.target.value)
  }


  return (
    <>
      <Helmet>
        <title>All  Challenge</title>
      </Helmet>
      <Appbar breadcrumb={breadcrumb} />
      {/* <DrawerUI /> */}
      <Body>




        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Button
            variant="contained"
            color="btn"
            startIcon={<AddIcon />}
            onClick={() => {
              // setCreateMission(true);
              //   dispatch(getCategoryAction());
              navigate("/createChallenge");
            }}
          >
            Create Challenge
          </Button>

          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Is Active</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={isActive}
                label="Is Active"
                onChange={handleChange}
              >
                <MenuItem value={0}>Select Option</MenuItem>
                <MenuItem value={1}>Active</MenuItem>
                <MenuItem value={2}>Not Active</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Is Mission</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={isMission}
                label="Is Mission"
                onChange={handleMissionChange}
                displayEmpty
              >
                <MenuItem value={0}>
                  <em>Select Option</em>
                </MenuItem>
                <MenuItem value={1}>Yes</MenuItem>
                <MenuItem value={2}>No</MenuItem>
              </Select>
            </FormControl>
          </Box>


          {/* <Button
            variant="contained"
            color="btn"
            // startIcon={<AddIcon />}
            onClick={() => {
              navigate("/createChallenge");
            }}
          >
            Submit
          </Button> */}

        </Stack>



        <Card sx={{ my: 2 }}>
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box sx={{ p: 2 }}>
                              <Typography color='#071D45'>Filter by Date</Typography>
                              <Stack direction={'row'} spacing={2} sx={{ mt: 1 }} alignItems='center'>
                                  <DatePicker
                                      label="Start Date"
                                      value={date?.start}
                                      onChange={(value) => setDate({ ...date, start: value })}
                                      renderInput={(params) => <TextField {...params} />}
                                      maxDate={date?.end}
  
                                  />
                                  <DatePicker
                                      label="End Date"
                                      value={date?.end}
                                      onChange={(value) => setDate({ ...date, end: value })}
                                      renderInput={(params) => <TextField {...params} />}
                                      minDate={date?.start}
                                  />
                                  <Box>
                                      <IconButton onClick={handleFilterData} color='#071D45'><FilterAltIcon /></IconButton>
                                  </Box>
                              </Stack>
                          </Box>
                      </LocalizationProvider> */}

          <Paper
            sx={{
              bgcolor: "#fff",
              "& .super-app-theme--header": {
                bgcolor: "#071D45",
                color: "#fff",
              },
            }}
            elevation={0}
          >
            <DataGrid
              className={classes.root}
              getRowHeight={() => "auto"}
              sx={{ border: 0 }}
              autoHeight
              rows={data}
              columns={qnsDataGridColumns}
              getRowId={(row) => row._id}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              pagination
              // pageSize={pageSize}
              // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[25, 5, 100]}
              disableColumnSelector
              loading={loading ? <LoadingUI /> : false}
              onCellClick={(params) => {
                setmission_id(params?.row?._id);
              }}
              components={{
                NoRowsOverlay: () => <NoDataFound />,
                Toolbar: GridToolbar,
              }}

              rowCount={total}
              paginationModel={setPageState}
              page={pageState.page}
              pageSize={pageState.pageSize}
              paginationMode="server"
              onPageChange={(newPage) => {
                setPageState(old => ({ ...old, page: newPage }))
              }}
              onPageSizeChange={(newPageSize) => setPageState(old => ({ ...old, pageSize: newPageSize }))}

            />
          </Paper>
        </Card>



        {/* <SnackBarUI state={snack} setState={setSnack} status={missionTimeStatus} message={missionTimeMsg} /> */}
      </Body>
    </>
  );
};

export default AllChallenge;
